// @ts-ignore
import { Biscuit } from "../../../../../utils";

interface Headers {
  "Accept-Language": string;
  "Content-Language": string;
}
interface LanguageHeader {
  headers: Headers;
}
export interface Settings {
  dispatch?: any;
  language?: string;
  usedContingentForm?: string;
  usedForm?: string;
  rentalType?: string;
  usedPriceForm?: string;
  languageHeader?: LanguageHeader;
  preSelectContingentForm?: boolean;
  userForm?: boolean;
  cart?: any;
  add?: boolean;
  id?: number | null;
  orderPending?: boolean;
  locationsPending?: boolean;
  reservationPending?: boolean;
  pricePending?: boolean;
  reservation?: any | null;
  order?: any | null;
  initialized?: boolean;
}
export const calenderFormModules = {
  bikeSharing: "bikeSharing",
  vehicleOwner: "vehicleOwner",
  appointment: "appointment",
};

export const acceptedResourceTypes = {
  Fahrzeuge: "vehicleOwner",
  Unterkünfte: "appointment",
  Bikesharing: "bikeSharing",
  Termine: "appointment",
  Stellplätze: "bikeSharing",
};
export const contingentFormModules = {
  bikeSharing: "bikeSharingContingents",
  vehicleOwner: "vehicleOwnerContingents",
  appointment: "vehicleOwnerContingents",
};

export const priceFormModules = {
  bikeSharing: "bikeSharingPrice",
  vehicleOwner: "vehicleOwnerPrice",
  appointment: "vehicleOwnerPrice",
};

export const initialSettings: Settings = {
  language: Biscuit.get("user.lang").replace("-", "_"),
  usedContingentForm:
    contingentFormModules[
      Biscuit.get("client.isVehicleOwner") === "true"
        ? "vehicleOwner"
        : Biscuit.get("client.isBikeSharing") === "true"
          ? "bikeSharing"
          : "appointment"
    ],
  usedForm:
    calenderFormModules[
      Biscuit.get("client.isVehicleOwner") === "true"
        ? "vehicleOwner"
        : Biscuit.get("client.isBikeSharing") === "true"
          ? "bikeSharing"
          : "appointment"
    ],
  rentalType:
    Biscuit.get("client.isVehicleOwner") === "true"
      ? "vehicleOwner"
      : Biscuit.get("client.isBikeSharing") === "true"
        ? "bikeSharing"
        : "appointment",
  usedPriceForm:
    priceFormModules[
      Biscuit.get("client.isVehicleOwner") === "true"
        ? "vehicleOwner"
        : Biscuit.get("client.isBikeSharing") === "true"
          ? "bikeSharing"
          : "appointment"
    ],
  languageHeader: {
    headers: {
      "Accept-Language": Biscuit.get("user.lang").replace("-", "_"),
      "Content-Language": Biscuit.get("user.lang").replace("-", "_"),
    },
  },
  preSelectContingentForm: false,
  userForm: false,
  cart: { priceRequestData: {} },
  add: false,
  id: null,
  orderPending: false,
  locationsPending: false,
  reservationPending: false,
  pricePending: false,
  reservation: null,
  initialized: false,
};
